import { Navigate } from "react-router-dom";
import Profile from "./components/Profile";
import AddCourse from "./pages/Admin/AddCourse";
import AddModule from "./pages/Admin/AddModule";
import AddUser from "./pages/Admin/AddUser";
import CourseCategory from "./pages/Admin/CourseCategory";
import ExamCreationList from "./pages/Admin/ExamCreationList";
import UserList from "./pages/Admin/UserList";
import Support from "./pages/User/Support";
import AdminLogin from "./pages/Login/AdminLogin";
import SendOtp from "./pages/Login/SendOtp";
import UserLogin from "./pages/Login/UserLogin";
import Forgot from "./pages/Login/Forgot";
import VerifyOtp from "./pages/Login/VerifyOtp";
import NotFound from "./pages/NotFound";
import Course from "./pages/User/Course";
import DetailedCourse from "./pages/User/DetailedCourse";
import Exam from "./pages/User/Exam";
import ExamCreation from "./pages/Admin/ExamCreation"
import UserGuard from "./guards/UserGuard";
import AdminGuard from "./guards/AdminGuard";
import TicketHistory from "./pages/User/TicketHistory";
import AdminTicketDashboard from "./pages/Admin/AdminTicketDashBoard";
import ForgotVerifyOtp from "./pages/Login/ForgotVerifyOtp";
import NewPassword from "./pages/Login/Newpassword";
import ForgotSendOtp from "./pages/Login/ForgotSendOtp";
import Suggestion from "./pages/Admin/Suggestions";
import ManageDashboard from "./pages/Admin/ManageDashboard";
import SuggestionsList from "./pages/Admin/SuggestionStatus";
import AdminDashboard from "./pages/Admin/AdminDashboard";
import ViewCourses from "./pages/User/ViewCourses";
import UserDashboard from "./pages/User/UserDashboard";



const routes = [
  { path: "*", element: <Navigate to="/not-found" replace /> },
  { path: "/", element: <UserLogin /> },
  { path: "/send-otp", element: <SendOtp /> },
  { path: "/verify-otp", element: <VerifyOtp /> },
  { path: "/admin-login", element: <AdminLogin /> },
  { path: '/forgot', element: <Forgot /> },
  { path: "/forgotverify-otp", element: <ForgotVerifyOtp /> },
  { path: '/new-password', element: <NewPassword /> },
  { path: '/forgotsend-otp', element: <ForgotSendOtp /> },
  { path: "/profile", element: <Profile /> },

  { path: "/user-list", element: <AdminGuard><UserList /></AdminGuard> },
  { path: "/suggestion", element: <AdminGuard><Suggestion /></AdminGuard> },
  { path: "/admin-dashboard", element: <AdminGuard><AdminDashboard /></AdminGuard> },
  { path: "/manage-dashboard", element: <AdminGuard><ManageDashboard /></AdminGuard> },
  { path: "/add-user", element: <AdminGuard><AddUser /></AdminGuard>, exact: true },
  { path: "/add-course", element: <AdminGuard>  <AddCourse />   </AdminGuard> },
  { path: "/add-modules", element: <AdminGuard><AddModule /></AdminGuard> },
  { path: "/exam-creation-list", element: <AdminGuard><ExamCreationList /></AdminGuard> },
  { path: "/not-found", element: <NotFound /> },
  { path: "/course-category", element: <AdminGuard><CourseCategory /></AdminGuard> },
  { path: "/admin-ticket-dashboard", element: <AdminGuard><AdminTicketDashboard /> </AdminGuard> },
  { path: "/suggestionList", element: <AdminGuard><SuggestionsList /> </AdminGuard> },


  { path: "/ticket-history", element: <UserGuard><TicketHistory /></UserGuard> },
  { path: "/support", element: <UserGuard><Support /></UserGuard> },
  { path: "/exam-creation", element: <AdminGuard><ExamCreation /></AdminGuard> },
  { path: "/course", element: <UserGuard><Course /></UserGuard> },
  { path: "/course/:id", element: <DetailedCourse /> },
  { path: "/exam", element: <Exam /> },
  { path: "/view-courses/:categoryId", element: <UserGuard><ViewCourses /></UserGuard> },
  { path: "/dashboard", element: <UserGuard><UserDashboard /></UserGuard> }
];

export default routes;


